import { css } from 'linaria';

export const drawer = css`
  --drawerWidth: 1039px !important;
`;

export const modalContentClassName = css`
  padding: var(--space-200);
`;

export const drawerHeader = css`
  z-index: 2;
  padding: var(--space-60) var(--space-400);

  > span {
    font-size: var(--space-325);
    line-height: var(--space-400);

    @media (--only-mobile) {
      font-size: var(--space-200);
      line-height: var(--space-300);
    }
  }
`;

export const drawerContent = css`
  /* HACK: important is used to cover fronton styles according to the design */
  padding: 0 !important;
`;
